import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({
    computed: {},
    methods: {},
});
let ItemSkill = class ItemSkill extends Mixins(UiMappers, DataMappers) {
};
__decorate([
    Prop()
], ItemSkill.prototype, "item", void 0);
ItemSkill = __decorate([
    Component({
        components: {},
    })
], ItemSkill);
export default ItemSkill;
